export default function touchMoveMenu({
  $el,
  panel,
  open,
  breakpoint = 1280,
  close,
  direction = 'LEFT',
  checkOpenState,
}) {
  let touchStartX = 0;
  let touchCurrentX = 0;
  let touchStartY = 0;
  let touchCurrentY = 0;
  let touchingSideNav = false;
  let isMovingX;
  let directionX = 0;

  function updateTouch() {
    if (!touchingSideNav) {
      return;
    }

    requestAnimationFrame(updateTouch);

    // 10 pixels gap to understand if is moving on X or Y axis
    if (typeof isMovingX === 'undefined' &&
      (Math.abs(touchCurrentX - touchStartX) > 10 || Math.abs(touchCurrentY - touchStartY) > 10)) {
      // If is moving on X axis
      if (Math.abs(touchCurrentX - touchStartX) > Math.abs(touchCurrentY - touchStartY)) {
        isMovingX = true;
      // If is moving on Y axis
      } else {
        isMovingX = false;
      }
    }

    if (typeof isMovingX !== 'undefined' && isMovingX) {
      const translateX = Math[direction === 'LEFT' ? 'min' : 'max'](0, touchCurrentX - touchStartX);
      panel.style.transform = `translateX(${translateX}px)`;
    }
  }

  function onTouchStart(evt) {
    if (checkOpenState(), window.innerWidth >= breakpoint) {
      return;
    }

    touchStartX = evt.touches[0].pageX;
    touchCurrentX = touchStartX;
    touchStartY = evt.touches[0].pageY;
    touchCurrentY = touchStartY;

    touchingSideNav = true;
    requestAnimationFrame(updateTouch);
  }

  function onTouchMove(evt) {
    if (!touchingSideNav) {
      return;
    }

    if (direction === 'LEFT') {
      directionX = touchCurrentX > evt.touches[0].pageX;
    } else if (direction === 'RIGHT') {
      directionX = touchCurrentX < evt.touches[0].pageX;
    }

    touchCurrentX = evt.touches[0].pageX;
    touchCurrentY = evt.touches[0].pageY;

    const translateX = Math[direction === 'LEFT' ? 'min' : 'max'](0, touchCurrentX - touchStartX);

    if (Math.abs(translateX) > 0 && isMovingX) {
      evt.preventDefault();
    }
  }

  function onTouchEnd() {
    if (!touchingSideNav) {
      return;
    }

    touchingSideNav = false;

    const translateX = Math[direction === 'LEFT' ? 'min' : 'max'](0, touchCurrentX - touchStartX);

    panel.style.transform = '';

    if (Math.abs(translateX) > 0 && directionX && isMovingX) {
      close();
    } else {
      open();
    }

    isMovingX = undefined;
  }

  //
  // Listeners
  //

  $el.addEventListener('touchstart', onTouchStart);
  $el.addEventListener('touchmove', onTouchMove);
  $el.addEventListener('touchend', onTouchEnd);
}



// WEBPACK FOOTER //
// ./src/scripts/utils/touch-move-menu.js